const capitalizeFieldHeader = (field) => {
  //seperate words of header form add set them to uppercase
  let words = field.split(/(?=[A-Z])/);
  words = words.join(" ");
  words = words.charAt(0).toUpperCase() + words.slice(1);
  return words;
};

export default capitalizeFieldHeader;
